import { cloneDeep } from 'lodash-es';

import { ILocalization } from '~/src/dash/api/console-api';
import { parseString, transformModel } from '~/src/dash/api/resource-transforms';
import { printDate } from '~/src/dash/utils/date';
import { IChangeLog, IChangeLogWithName } from '~/src/dash/views/publisher/change-logs/interfaces';
import { dataToRow } from '~/src/dash/views/publisher/change-logs/utils';

export const transformChangeLog = transformModel<IChangeLog>({
  ID: parseString(['ID']),
  CreatedAt: 'CreatedAt',
  UserID: parseString(['UserID']),
  AffectedItemID: parseString(['AffectedItemID']),
  TableAffected: parseString(['TableAffected']),
  ActionTaken: parseString(['ActionTaken']),
  ChangesMade: parseString(['ChangesMade']),
  UserName: parseString(['UserName']),
  SiteName: parseString(['SiteName']),
  HeaderBidderName: parseString(['HeaderBidderName']),
  AdserverCampaignName: parseString(['AdserverCampaignName']),
  ChannelGroupName: parseString(['ChannelGroupName']),
  BidderGroupName: parseString(['BidderGroupName']),
  NetworkName: parseString(['NetworkName']),
  AdserverOrderName: parseString(['AdserverOrderName']),
  CompanyName: parseString(['CompanyName']),
  BrandSafetyRuleName: parseString(['BrandSafetyRuleName']),
  RouteName: parseString(['RouteName']),
  ContextualSegment: parseString(['ContextualSegment']),
  ReportName: parseString(['ReportName']),
});

export const transformChangeLogs = (
  changeLogs: IChangeLog[],
  localization: ILocalization,
): IChangeLogWithName[] => {
  const formattedChangeLogs = changeLogs.map((log: IChangeLog): IChangeLog => {
    const newLog = cloneDeep(log);
    newLog.CreatedAt = printDate(log.CreatedAt, localization);
    if (newLog.ChangesMade === '') {
      newLog.ChangesMade = JSON.parse('{}');
      return newLog;
    } else {
      let changesMade = {};
      try {
        changesMade = JSON.parse(log.ChangesMade);
      } catch (e) {
        changesMade = { error: 'cannot parse', rawData: log.ChangesMade };
        console.error(e);
      }
      newLog.ChangesMade = changesMade;
      return newLog;
    }
  });
  return dataToRow(formattedChangeLogs);
};
